import { useContent } from '@altify/utils';
import { useControllableState } from '@rn-primitives/hooks';
import { useState } from 'react';
import { Pressable, View } from 'react-native';
import { CancelXIcon } from '../../Icons/CancelXIcon';
import { cn } from '../../lib/utils';
import { TextField } from '../TextInput/TextField';
import { content } from './SearchBar.content';
import { SearchIcon } from './SearchIcon';

export const SearchBar = ({
  value,
  defaultValue = '',
  onValueChanged,
  maxLength = 20,
  onFocus,
  onBlur,
  className,
  fullWidth,
  showClearIcon = true,
  placeholder,
}: {
  value?: string;
  defaultValue?: string;
  onValueChanged?: (value: string) => void;
  maxLength?: number;
  onFocus?: () => void;
  onBlur?: () => void;
  className?: string;
  fullWidth?: boolean;
  showClearIcon?: boolean;
  placeholder?: string;
}) => {
  const [internalValue, handleValueChanged] = useControllableState({
    prop: value,
    onChange: onValueChanged,
    defaultProp: defaultValue,
  });

  const [isFocused, setIsFocused] = useState(false);
  const localizedContent = useContent(content);

  const border = isFocused
    ? 'border-2 border-primary'
    : 'border border-neutral-300';
  const onTextFocus = () => {
    onFocus?.();
    setIsFocused(true);
  };
  const onTextBlur = () => {
    onBlur?.();
    setIsFocused(false);
  };
  return (
    <View
      className={cn(
        'flex-row items-center h-[46px] rounded-full',
        border,
        className,
      )}>
      <SearchIcon
        fill="white"
        className="absolute left-3 pointer-events-none"
      />
      <TextField
        fullWidth={fullWidth}
        style={{
          fontSize: 15,
          fontWeight: '400',
          lineHeight: 18,
        }}
        className="h-full w-full px-11"
        maxLength={maxLength}
        placeholder={placeholder ?? localizedContent.search}
        value={internalValue}
        onValueChanged={handleValueChanged}
        onFocus={onTextFocus}
        onBlur={onTextBlur}
      />
      {showClearIcon && internalValue && (
        <Pressable
          onPress={() => handleValueChanged?.('')}
          className="absolute right-4">
          <CancelXIcon />
        </Pressable>
      )}
    </View>
  );
};
